import React, { useMemo, useRef } from 'react';
import { Dropdown } from 'react-bootstrap';

import { WORK_SHOWS } from '../../utils/constant/global';

import './SidebarWorkShow.scss';

function SidebarWorkShow({ selectedWorkShow, onWorkShowChange, isSidebarMini }) {
  const dropdownWrapRef = useRef(null);
  const activeWorkShow = WORK_SHOWS.find((ws) => ws.id === selectedWorkShow) || WORK_SHOWS[0];

  const menuPopperConfig = useMemo(
    () => ({
      strategy: 'absolute',
      modifiers: [
        {
          name: 'matchSelectorWidth',
          enabled: true,
          phase: 'beforeWrite',
          requires: ['computeStyles'],
          fn: ({ state }) => {
            const width = dropdownWrapRef.current?.offsetWidth ?? state.rects.reference.width;
            state.styles.popper.width = `${width}px`;
            state.styles.popper.minWidth = `${width}px`;
            state.styles.popper.maxWidth = `${width}px`;
          }
        },
        {
          name: 'offset',
          options: { offset: [0, 6] }
        },
        {
          name: 'preventOverflow',
          options: { padding: 8, altAxis: true }
        }
      ]
    }),
    []
  );

  return (
    <div
      className={`sidebar-work-show mt-2 pb-0 flex-shrink-0 ${isSidebarMini ? 'sidebar-work-show--mini' : ''}`}
    >
      <div ref={dropdownWrapRef} className="sidebar-work-show__dropdown">
        <Dropdown drop="down" align="start" className="sidebar-work-show__dropdown-inner">
          <Dropdown.Toggle
            variant="link"
            id="sidebar-work-show-menu"
            className={`sidebar-work-show__toggle text-decoration-none shadow-none ${isSidebarMini ? 'sidebar-work-show__toggle--mini' : ''}`}
            aria-label={`Work show: ${activeWorkShow.label}, ${activeWorkShow.region}`}
          >
            <span className="sidebar-work-show__code-wrap" aria-hidden>
              <span className="sidebar-work-show__code">{activeWorkShow.countryCode}</span>
            </span>

            {!isSidebarMini ? (
              <span className="sidebar-work-show__meta">
                <span className="sidebar-work-show__name">{activeWorkShow.label}</span>
                <span className="sidebar-work-show__sub">
                  {activeWorkShow.region}
                  <span className="sidebar-work-show__dot" aria-hidden />
                  {activeWorkShow.timezone}
                </span>
              </span>
            ) : (
              <span
                className="sidebar-work-show__mini-meta"
                title={`${activeWorkShow.label} (${activeWorkShow.timezone})`}
              >
                <span className="sidebar-work-show__mini-name">{activeWorkShow.shortLabel}</span>
              </span>
            )}

            <i className="icofont-rounded-down sidebar-work-show__caret" aria-hidden />
          </Dropdown.Toggle>

          <Dropdown.Menu
            className="sidebar-work-show__menu shadow border-0"
            popperConfig={menuPopperConfig}
          >
            <Dropdown.Header className="sidebar-work-show__menu-title">
              Choose office
            </Dropdown.Header>
            {WORK_SHOWS.map((ws) => {
              const isSelected = ws.id === selectedWorkShow;
              return (
                <Dropdown.Item
                  key={ws.id}
                  active={isSelected}
                  className={`sidebar-work-show__item ${isSelected ? 'is-selected' : ''}`}
                  onClick={() => onWorkShowChange(ws.id)}
                >
                  <span className="sidebar-work-show__item-code">{ws.countryCode}</span>
                  <span className="sidebar-work-show__item-body">
                    <span className="sidebar-work-show__item-name">{ws.label}</span>
                    <span className="sidebar-work-show__item-sub">
                      {ws.region} · {ws.timezone}
                    </span>
                  </span>
                  <span
                    className={`sidebar-work-show__item-radio ${isSelected ? 'is-checked' : ''}`}
                    aria-hidden
                  />
                </Dropdown.Item>
              );
            })}
          </Dropdown.Menu>
        </Dropdown>
      </div>
    </div>
  );
}

export default SidebarWorkShow;
